/**
 * Product Upsell Snippet JavaScript
 * 
 * Funktionalität:
 * - Embla Carousel Initialisierung für Multiple Upsells
 * - Plus/Minus Toggle für Upsell-Auswahl
 * - localStorage Management für vorgemerkte Produkte
 * - Auto-Add zum Warenkorb beim Hauptprodukt-Kauf
 * - Varianten-Auswahl mit dynamischer Preis-Aktualisierung
 */

(function() {
  'use strict';
  
  var STORAGE_KEY = 'nilo_upsell_products';
  
  /**
   * Wait for Embla Carousel library to load
   */
  function waitForEmbla(callback, timeout) {
    timeout = timeout || 5000;
    var startTime = Date.now();
    
    function check() {
      if (typeof EmblaCarousel !== 'undefined') {
        console.log('[Upsell] EmblaCarousel loaded');
        callback();
      } else if (Date.now() - startTime < timeout) {
        setTimeout(check, 100);
      } else {
        console.error('[Upsell] EmblaCarousel failed to load');
      }
    }
    
    check();
  }
  
  /**
   * Initialize Embla Carousel
   */
  function initEmblaCarousel() {
    var emblaRoot = document.querySelector('[data-embla]');
    if (!emblaRoot) {
      console.log('[Upsell] No carousel (single upsell)');
      return;
    }
    
    var viewportNode = emblaRoot.querySelector('.embla__viewport');
    if (!viewportNode) {
      console.error('[Upsell] Viewport not found');
      return;
    }
    
    console.log('[Upsell] Initializing carousel...');
    
    waitForEmbla(function() {
      var emblaApi = EmblaCarousel(viewportNode, {
        align: 'start',
        containScroll: 'trimSnaps',
        slidesToScroll: 1,
        skipSnaps: false,
        draggable: true,
        dragFree: false
      });
      
      console.log('[Upsell] Carousel initialized');
      
      var dotsContainer = document.querySelector('.embla__dots');
      var slides = emblaRoot.querySelectorAll('.embla__slide');
      
      if (!dotsContainer || slides.length === 0) {
        return;
      }
      
      dotsContainer.innerHTML = '';
      console.log('[Upsell] Creating ' + slides.length + ' dots');
      
      for (var i = 0; i < slides.length; i++) {
        var dot = document.createElement('button');
        dot.className = 'embla__dot';
        dot.type = 'button';
        dot.setAttribute('aria-label', 'Zu Slide ' + (i + 1) + ' gehen');
        
        (function(index) {
          dot.addEventListener('click', function() {
            console.log('[Upsell] Dot ' + index + ' clicked');
            emblaApi.scrollTo(index);
          });
        })(i);
        
        dotsContainer.appendChild(dot);
      }
      
      var updateDots = function() {
        var dots = dotsContainer.querySelectorAll('.embla__dot');
        var selectedIndex = emblaApi.selectedScrollSnap();
        
        for (var j = 0; j < dots.length; j++) {
          if (j === selectedIndex) {
            dots[j].classList.add('is-selected');
          } else {
            dots[j].classList.remove('is-selected');
          }
        }
      };
      
      emblaApi.on('select', updateDots);
      emblaApi.on('reInit', updateDots);
      updateDots();
    });
  }
  
  /**
   * Get selected upsells from localStorage
   */
  function getSelectedUpsells() {
    try {
      var stored = localStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch (error) {
      console.error('[Upsell] Error reading localStorage:', error);
      return [];
    }
  }
  
  /**
   * Save selected upsells to localStorage
   */
  function saveSelectedUpsells(upsells) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(upsells));
      console.log('[Upsell] Saved to localStorage:', upsells);
    } catch (error) {
      console.error('[Upsell] Error saving to localStorage:', error);
    }
  }
  
  /**
   * Toggle upsell selection
   */
  function toggleUpsell(button) {
    var item = button.closest('.upsell-item');
    if (!item) return;
    
    var productId = item.getAttribute('data-product-id');
    var variantInput = item.querySelector('[data-upsell-variant]');
    var variantId = variantInput ? variantInput.value : null;
    
    if (!productId || !variantId) {
      console.error('[Upsell] Missing product/variant ID');
      return;
    }
    
    var plusIcon = button.querySelector('.upsell-plus');
    var minusIcon = button.querySelector('.upsell-minus');
    var selectedUpsells = getSelectedUpsells();
    var existingIndex = -1;
    
    for (var i = 0; i < selectedUpsells.length; i++) {
      if (selectedUpsells[i].productId === productId) {
        existingIndex = i;
        break;
      }
    }
    
    if (existingIndex >= 0) {
      selectedUpsells.splice(existingIndex, 1);
      item.classList.remove('selected');
      if (plusIcon) plusIcon.style.display = '';
      if (minusIcon) minusIcon.style.display = 'none';
      console.log('[Upsell] Deselected:', productId);
    } else {
      selectedUpsells.push({
        productId: productId,
        variantId: variantId
      });
      item.classList.add('selected');
      if (plusIcon) plusIcon.style.display = 'none';
      if (minusIcon) minusIcon.style.display = '';
      console.log('[Upsell] Selected:', productId, variantId);
    }
    
    saveSelectedUpsells(selectedUpsells);
  }
  
  /**
   * Restore selected state on page load
   */
  function restoreSelections() {
    var selectedUpsells = getSelectedUpsells();
    if (!selectedUpsells.length) return;
    
    var items = document.querySelectorAll('.upsell-item');
    
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var productId = item.getAttribute('data-product-id');
      var isSelected = false;
      
      for (var j = 0; j < selectedUpsells.length; j++) {
        if (selectedUpsells[j].productId === productId) {
          isSelected = true;
          break;
        }
      }
      
      if (isSelected) {
        item.classList.add('selected');
        var button = item.querySelector('[data-upsell-toggle]');
        if (button) {
          var plusIcon = button.querySelector('.upsell-plus');
          var minusIcon = button.querySelector('.upsell-minus');
          if (plusIcon) plusIcon.style.display = 'none';
          if (minusIcon) minusIcon.style.display = '';
        }
      }
    }
  }
  
  /**
   * Update variant selection in localStorage when dropdown changes
   */
  function updateVariantInStorage(productId, newVariantId) {
    var selectedUpsells = getSelectedUpsells();
    
    for (var i = 0; i < selectedUpsells.length; i++) {
      if (selectedUpsells[i].productId === productId) {
        selectedUpsells[i].variantId = newVariantId;
        saveSelectedUpsells(selectedUpsells);
        console.log('[Upsell] Updated variant:', productId, newVariantId);
        return;
      }
    }
  }
  
  /**
   * Find add-to-cart form with multiple selectors
   * Prioritizes theme-specific selectors first
   */
  function findAddToCartForm() {
    var selectors = [
      'form.main-form[data-cart-submit]',
      'form[data-cart-submit]',
      'form.main-form',
      'form[action="/cart/add"]',
      'form[action*="/cart/add"]',
      'form[action*="/cart/add.js"]',
      'form.product-form',
      'form[data-product-form]',
      '[data-product-form]'
    ];
    
    for (var i = 0; i < selectors.length; i++) {
      var form = document.querySelector(selectors[i]);
      if (form) {
        console.log('[Upsell] Found form:', selectors[i]);
        return form;
      }
    }
    
    console.warn('[Upsell] No add-to-cart form found');
    return null;
  }
  
  /**
   * Handle adding main product + upsells to cart
   */
  function handleAddToCart(event, form) {
    var selectedUpsells = getSelectedUpsells();
    
    if (!selectedUpsells || !selectedUpsells.length) {
      console.log('[Upsell] No upsells selected');
      return;
    }
    
    event.preventDefault();
    event.stopPropagation();
    
    console.log('[Upsell] Intercepting add to cart');
    
    var formData = new FormData(form);
    var mainVariantId = formData.get('id');
    
    if (!mainVariantId) {
      var idInput = form.querySelector('[name="id"]');
      if (idInput) {
        mainVariantId = idInput.value;
      }
    }
    
    if (!mainVariantId) {
      console.error('[Upsell] Main variant ID not found');
      form.submit();
      return;
    }
    
    var quantityValue = formData.get('quantity');
    var quantity = parseInt(quantityValue, 10);
    if (!quantity || isNaN(quantity)) {
      quantity = 1;
    }
    
    console.log('[Upsell] Main product:', mainVariantId, 'qty:', quantity);
    
    var items = [{ id: mainVariantId, quantity: quantity }];
    
    for (var i = 0; i < selectedUpsells.length; i++) {
      var upsell = selectedUpsells[i];
      if (upsell.variantId) {
        items.push({
          id: upsell.variantId,
          quantity: 1
        });
        console.log('[Upsell] Adding upsell:', upsell.variantId);
      }
    }
    
    console.log('[Upsell] Total items:', items.length);
    
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: items })
    })
      .then(function(response) {
        if (response.ok) {
          console.log('[Upsell] Successfully added to cart');
          localStorage.removeItem(STORAGE_KEY);
          window.location.href = '/cart';
        } else {
          return response.text().then(function(text) {
            console.error('[Upsell] Error response:', text);
            form.submit();
          });
        }
      })
      .catch(function(error) {
        console.error('[Upsell] Fetch error:', error);
        form.submit();
      });
  }
  
  /**
   * Intercept add-to-cart form submit and button click
   */
  function interceptAddToCart() {
    var addToCartForm = findAddToCartForm();
    if (!addToCartForm) {
      console.error('[Upsell] No form found, retrying...');
      setTimeout(interceptAddToCart, 500);
      return;
    }
    
    console.log('[Upsell] Intercepting form submit & button click');
    
    // Intercept form submit (fallback)
    addToCartForm.addEventListener('submit', function(event) {
      handleAddToCart(event, addToCartForm);
    }, true);
    
    // Intercept button click (primary method for this theme)
    var addToCartButton = addToCartForm.querySelector('.add-to-cart-form-button');
    if (addToCartButton) {
      console.log('[Upsell] Found add-to-cart button');
      
      addToCartButton.addEventListener('click', function(event) {
        var selectedUpsells = getSelectedUpsells();
        
        if (selectedUpsells && selectedUpsells.length > 0) {
          console.log('[Upsell] Button clicked with upsells selected – handling via upsell script');
          handleAddToCart(event, addToCartForm);
        } else {
          console.log('[Upsell] Button clicked but no upsells selected – letting theme handle it');
        }
      }, true);
    } else {
      console.warn('[Upsell] No .add-to-cart-form-button found in form');
    }
  }
  
  /**
   * Initialize all functionality
   */
  function init() {
    console.log('[Upsell] Initializing...');
    
    initEmblaCarousel();
    restoreSelections();
    interceptAddToCart();
    
    var toggleButtons = document.querySelectorAll('[data-upsell-toggle]');
    for (var i = 0; i < toggleButtons.length; i++) {
      toggleButtons[i].addEventListener('click', function(e) {
        e.preventDefault();
        toggleUpsell(this);
      });
    }
    
    var variantFields = document.querySelectorAll('[data-upsell-variant]');
    for (var j = 0; j < variantFields.length; j++) {
      var field = variantFields[j];
      if (field.tagName === 'SELECT') {
        field.addEventListener('change', function() {
          var selectedOption = this.options[this.selectedIndex];
          var price = selectedOption ? selectedOption.getAttribute('data-price') : null;
          var productId = this.getAttribute('data-product-id');
          var variantId = this.value;
          
          var content = this.closest('.upsell-content');
          if (content && price) {
            var priceElement = content.querySelector('[data-price-display]');
            if (priceElement) {
              priceElement.textContent = price;
            }
          }
          
          if (productId && variantId) {
            updateVariantInStorage(productId, variantId);
          }
        });
      }
    }
    
    console.log('[Upsell] Initialization complete');
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
